import { render } from "./SwitchComponent.vue?vue&type=template&id=10629f66&scoped=true"
import script from "./SwitchComponent.vue?vue&type=script&lang=js"
export * from "./SwitchComponent.vue?vue&type=script&lang=js"

import "./SwitchComponent.vue?vue&type=style&index=0&id=10629f66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10629f66"]])

export default __exports__